const SettingsCard = ({ title, description, children, className = '' }) => {
  const baseClasses = 'rounded-xl border border-customBorder/40 dark:bg-custom_dark_primary2 bg-customFontMilkWhite px-6 py-6 shadow-xl backdrop-blur-sm';
  const sectionClasses = [baseClasses, className].filter(Boolean).join(' ');

  return (
    <section className={sectionClasses}>
      <div className="mb-6 space-y-2">
        <h2 className="text-xl font-semibold dark:text-customHeading text-background">{title}</h2>
        {description ? (
          <p className="text-sm dark:text-customMuted text-primary" data-testid="settings-card-description">
            {description}
          </p>
        ) : null}
      </div>
      {children}
    </section>
  );
};

export default SettingsCard;
